/*
 * report-job (zod)
 */
import { createInsertSchema, createSelectSchema } from "drizzle-zod"
import * as z from "zod"
import { globalCreateExclude, globalUpdateExclude } from "../utils/constants"
import { reportJobs } from "./report-job.schema"

/* Select */
export type ReportJob = z.infer<typeof selectReportJobSchema>
export const selectReportJobSchema = createSelectSchema(reportJobs)

/* Filters */
export type ReportJobFilters = z.infer<typeof reportJobFiltersSchema>
export const reportJobFiltersSchema = z.object({
	id: z.string().optional(),
	userId: z.string().optional(),
	reportType: z.string().optional(),
	status: z.string().optional(),
	active: z.boolean().optional(),
})

/* Create */
export const createReportJobSchema = createInsertSchema(reportJobs).partial(globalCreateExclude)
export type CreateReportJob = z.infer<typeof createReportJobSchema>

/* Update */
export const updateReportJobSchema = createInsertSchema(reportJobs)
	.omit(globalUpdateExclude)
	.partial()
	.required({ id: true })
export type UpdateReportJob = z.infer<typeof updateReportJobSchema>

/* Report Filters (the filters stored inside a job) */
export const REPORT_TYPES = ["client_master"] as const
export type ReportType = (typeof REPORT_TYPES)[number]

export const clientMasterFiltersSchema = z.object({
	activePrescriptionOnly: z.boolean().default(false),
	producerIds: z.array(z.string().uuid()).optional(),
	clientStatuses: z.array(z.string()).optional(),
	vacApprovalEndFrom: z.string().optional(),
	vacApprovalEndTo: z.string().optional(),
	prescriptionExpiryFrom: z.string().optional(),
	prescriptionExpiryTo: z.string().optional(),
})
export type ClientMasterFilters = z.infer<typeof clientMasterFiltersSchema>
